// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timeline-list.is-branch{padding-top:0;position:relative;left:-5px}.bg-50-icon__success{background-color:#e5f9ed!important}.bg-50-icon__warning{background-color:#fffbf2!important}", ""]);
// Exports
module.exports = exports;
